module.exports = __webpack_public_path__ + "img/placeholder-map.86e44d22.jpg";